import $x from '@/utils/$x';

// 动作列表
export async function getActionList(params) {
  return $x.post('/aiManage/getAIActionList', params);
}
// 新增or修改动作
export async function saveAIAction(params) {
  return $x.post('/aiManage/saveAIAction', params);
}

// 开通 or 关闭 动作的AI分析功能
export async function manageAIActionStatus(params) {
  return $x.post('/aiManage/manageAIActionStatus', params);
}
// 查询指定动作的特征数据
export async function getActionFeatureList(params) {
  return $x.post('/aiManage/getActionFeatureList', params);
}
// 保存动作的特征数据
export async function saveActionFeature(params) {
  return $x.post('/aiManage/saveActionFeature', params);
}
// 删除动作的特征数据
export async function delActionFeature(params) {
  return $x.post('/aiManage/delActionFeature', params);
}
// 查询指定动作-指定节点特征数据配置的基础特征值权重
export async function getActionFeatureWeight(params) {
  return $x.post('/aiManage/getActionFeatureWeight', params);
}
// 设置动作特征数据-基础特征权重
export async function saveVisualNodeWeight(params) {
  return $x.post('/aiManage/saveVisualNodeWeight', params);
}

// 查询指定动作的问题点列表
export async function getActionProblemList(params) {
  return $x.post('/aiManage/getActionProblemList', params);
}

// 设置动作特征数据和问题点的关联关系（绑定 or 解绑）
export async function handleActionFeatureAndProblemRel(params) {
  return $x.post('/aiManage/handleActionFeatureAndProblemRel', params);
}

// 查询指定动作特征数据的基础特征维度得分
export async function getActionFrameFeatureData(params) {
  return $x.post('/aiManage/getActionFrameFeatureData', params);
}

// 保存动作特征数据（即视角节点）-问题点关联
export async function saveVisualNodeProblem(params) {
  return $x.post('/aiManage/saveVisualNodeProblem', params);
}

// 查询基础特征数据
export async function getActionFrameFeature(params) {
  return $x.post('/aiManage/getActionFrameFeature', params);
}
// 保存基础特征数据
export async function saveFrameFeature(params) {
  return $x.post('/aiManage/saveFrameFeature', params);
}
